import React from 'react'
import Typography from '@material-ui/core/Typography'
const PageNotFound = () => (
  <div>
    <Typography variant='subtitle1'>Page not found</Typography>
  </div>
)

export default PageNotFound
